import React from "react";
import { useI18N } from "@src/language/language-context";
import { Input2025 } from "@src/components/atoms/input-2025/input-2025";

/**
 * Shared `Scale` input for the widget editors. A plain text field so a German
 * comma decimal ("0,01") types naturally; the editor parses it into the saved
 * `encoding.transforms` at save time. Rendered under the node it scales.
 */
export const ScaleInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (raw: string) => void;
}) => {
  const i18n = useI18N();
  return (
    <Input2025
      labelText={i18n("modules.scaleInput.scaleLabel")}
      inputPlaceHolder={i18n("modules.scaleInput.scalePlaceholder")}
      inputValue={value}
      onChangeFunc={(event) => onChange(event.target.value)}
      inputVariant="dark-background"
    />
  );
};
